import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { User                     } from 'src/app/beans/login/user/user.bean';
import { HandlerManager           } from 'src/app/managers/handler/handler.manager';
import { LoadingManager           } from 'src/app/managers/loading/loading.manager';
import { SessionManager           } from 'src/app/managers/session/session.manager';
import { Organization             } from 'src/app/beans/organization/organization.bean';
import { OMOperator               } from 'src/app/beans/operator/operator.bean';
import { Observable, of               } from 'rxjs';
import { FormControl              } from '@angular/forms';
import { map, startWith           } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component
({
  selector: 'autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})

export class AutocompleteComponent implements OnInit 
{
  values  : OMOperator[] = []
  services: any       [] = []

  currentValue: OMOperator
  
  filteredOptions: Observable<OMOperator[]>

  myControl: FormControl = new FormControl();

  @ViewChild( 'genInput'   , { read: MatAutocompleteTrigger  } ) genTrigger: MatAutocompleteTrigger;

  @Input('org') set _organization(organization: Organization)
  {    
    if(organization) this.init(organization.id)
  }

  @Output('onChange') onChange: EventEmitter<OMOperator> = new EventEmitter<OMOperator>() 
  constructor
  ( 
    private _handler: HandlerManager ,
    private _loader : LoadingManager ,
    private _session: SessionManager ,
  ) {
    this.myControl.valueChanges.subscribe(
      async (operator: string | OMOperator) =>{
        if(OMOperator.isKind( operator )){
          this.currentValue = operator as OMOperator

          operator = this.currentValue.loginName + " - " + this.currentValue.authorization
        }
        this.filteredOptions = of( this._filter(operator as string ) )
      }
    )
  }

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.values.slice())
      );
  }

  displayFn(operator: OMOperator): string 
  {
    return operator && operator.loginName ? operator.loginName : '';
  }

  private _filter(name: string): OMOperator[] 
  {

    if(!name) name = ""
    try{
      const filterValue = name.toLowerCase();
      const filter = this.values.filter(option => option?.loginName?.toLowerCase().indexOf(filterValue) > -1 || option?.authorization?.toLowerCase().indexOf(filterValue) > -1 );
      
      return filter
    }catch(error){ return []  }

  }

  async init( organizationId: number )
  {
    //Set operator list
    this.values = await this.retriveOperatorList( organizationId )
  }

  async retriveOperatorList( organizationId: number )
  {
    const user  = this._session.user().get()

    if (!User.isKind( user )) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
    response = await this._handler.operator().getOperatorList(( user as User ).token, organizationId )

    this._loader.stop()

    if ( !response        ) return
    if ( !response.list   ) return

    return response.list as OMOperator[];
  }

  //Get loginId
  async isChange(event: any)
  {
    let obj = event.option.value as OMOperator
    
    this.currentValue = obj

    this.onChange.emit( this.currentValue )
  }

  getSelectedValue()
  {
    return this.currentValue
  }

  async focused(param?: any){
    const place = this.myControl.value
    this.filteredOptions = of( this._filter(place) )

      //setTimeout( ()=>{ this.placeTrigger.openPanel()}, 100)
  }

}
